(ns manage.poi.locations.form
  (:require ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [cljs-bean.core :refer [->clj]]
            [clojure.string :as str]
            [common.form :as form]
            [common.util :as util]
            [common.widgets.form-field :refer [form-field hint]]
            [manage.poi.locations.columns :refer [days periods->str]]
            [uix.core :refer [$]]))

(defn- str->periods [s]
  (when (seq s)
    (let [[from to] (str/split s #"-" 2)]
      [[from to]])))

(defn location-default-values [location]
  (let [data (:data location)]
    (->
     #js {:external-id (:external-id data)
          :lat (:lat data)
          :lon (:lon data)
          :name (:name data)
          :address (:address data)
          :city (:city data)
          :postcode (:postcode data)
          :phone (:phone data)
          :labels (to-array (:labels data))
          :always-open (boolean (:always-open data))
          :always-closed (boolean (:always-closed data))
          :timezone (:timezone data)}
     (as-> defaults
       (reduce (fn [^js obj day]
                 (aset obj day (or (periods->str (get data (keyword day))) ""))
                 obj)
               defaults
               days)))))

(defn build-location-payload [^js form-data]
  (let [d (->clj form-data)]
    (reduce (fn [m day]
              (assoc m (keyword day) (str->periods (get d (keyword day)))))
            {:external-id (:external-id d)
             :lat (js/parseFloat (:lat d))
             :lon (js/parseFloat (:lon d))
             :name (not-empty (:name d))
             :address (not-empty (:address d))
             :city (not-empty (:city d))
             :postcode (not-empty (:postcode d))
             :phone (not-empty (:phone d))
             :labels (not-empty (vec (:labels d)))
             :always-open (:always-open d)
             :always-closed (:always-closed d)
             :timezone (not-empty (:timezone d))}
            days)))

(def empty-location-defaults
  #js {:external-id ""
       :lat ""
       :lon ""
       :name ""
       :address ""
       :city ""
       :postcode ""
       :phone ""
       :labels #js []
       :always-open false
       :always-closed false
       :timezone ""
       :monday ""
       :tuesday ""
       :wednesday ""
       :thursday ""
       :friday ""
       :saturday ""
       :sunday ""})

(defn location-form-fields [{:keys [control watch available-labels disable-external-id?]}]
  (let [always-open? (watch "always-open")
        always-closed? (watch "always-closed")]
    ($ Stack {:spacing 2}
       ($ form-field {:label "External ID" :required? true}
          ($ form/form-text-field {:name "external-id" :control control
                                   :rules #js {:required "Required"}
                                   :field-props {:disabled (boolean disable-external-id?) :size "small"}}))
       ($ Stack {:direction "row" :spacing 2}
          ($ form-field {:label "Latitude" :required? true}
             ($ form/form-text-field {:name "lat" :control control
                                      :rules #js {:required "Required"}
                                      :field-props {:size "small" :type "number"}}))
          ($ form-field {:label "Longitude" :required? true}
             ($ form/form-text-field {:name "lon" :control control
                                      :rules #js {:required "Required"}
                                      :field-props {:size "small" :type "number"}})))
       ($ form-field {:label "Name"}
          ($ form/form-text-field {:name "name" :control control
                                   :field-props {:size "small"}}))
       ($ form-field {:label "Address"}
          ($ form/form-text-field {:name "address" :control control
                                   :field-props {:size "small"}}))
       ($ form-field {:label "City"}
          ($ form/form-text-field {:name "city" :control control
                                   :field-props {:size "small"}}))
       ($ Stack {:direction "row" :spacing 2}
          ($ form-field {:label "Postcode"}
             ($ form/form-text-field {:name "postcode" :control control
                                      :field-props {:size "small"}}))
          ($ form-field {:label "Phone"}
             ($ form/form-text-field {:name "phone" :control control
                                      :field-props {:size "small"}})))
       ($ form-field {:label "Labels"}
          ($ form/autocomplete-field
             {:name "labels"
              :control control
              :field-props {:options (mapv (fn [t] {:value t :label t}) (or available-labels []))
                            :multi? true
                            :free-solo? true
                            :placeholder "Select labels..."}}))
       ($ Stack {:direction "row" :spacing 4}
          ($ form/switch {:name "always-open" :control control :label "Open 24/7"})
          (when-not always-open?
            ($ form/switch {:name "always-closed" :control control :label "Closed 24/7"})))
       (when-not (or always-open? always-closed?)
         ($ :<>
            ($ form-field {:label "Timezone"}
               ($ form/autocomplete-field
                  {:name "timezone"
                   :control control
                   :field-props {:options (mapv (fn [tz] {:value tz :label tz}) util/timezones)
                                 :placeholder "Select timezone..."}}))
            ($ Typography {:variant "subtitle2" :sx #js {:mt 1}} "Opening Hours")
            ($ hint "Format: HH:MM-HH:MM, range 00:00–24:00")
            (for [day days]
              ($ Stack {:key day :direction "row" :spacing 1 :alignItems "center"}
                 ($ Typography {:variant "body2" :sx #js {:width "90px" :textTransform "capitalize"}} day)
                 ($ form/form-text-field {:name day :control control
                                          :field-props {:size "small" :placeholder "09:00-17:00"
                                                        :sx #js {:width "150px"}}
                                          :rules #js {:pattern #js {:value #"^([01]\d|2[0-4]):[0-5]\d-([01]\d|2[0-4]):[0-5]\d$"
                                                                    :message "HH:MM-HH:MM"}}}))))))))
